import type { CrudMessages, Dictionary } from '../models'

import { LocaleEnum, RestrictedValueEnum } from '../enums'

const CRUD_MESSAGES_EN: CrudMessages = {
  clearSelection: 'Clear selection',
  actions: {
    create: 'New',
    clone: 'Clone',
    update: 'Edit',
    delete: 'Delete',
    enable: 'Turn on',
    disable: 'Turn off',
    bulkEdit: 'Multi-editing',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    accept: 'Accept',
    uploading: 'Uploading',
  },
  sections: {
    details: 'Details',
    configuration: 'Configuration',
  },
  status: {
    enabled: 'On',
    disabled: 'Off',
  },
  restricted: {
    [RestrictedValueEnum.READ]: 'Restricted',
  },
  schedule: {
    from: 'From {date}',
    to: 'To {date}',
    always: 'Always',
  },
  empty: 'Empty',
  search: 'Search',
  strictMatchingTooltip: 'Results will match the entire query entered.',
  noDataFound: 'We couldn’t find any data that match your search.',
  dataFiltered: ` Try removing some filters and searching again.`,
  pagination: {
    rows: 'rows',
    pages: {
      first: 'First page',
      previous: 'Previous page',
      next: 'Next page',
      last: 'Last page',
    },
    ofTotal: 'of',
    download: {
      action: 'Download',
      actionTitle: 'Download report',
      currentPage: 'Current page',
      allRows: 'All rows',
      custom: 'Custom',
      startingRow: 'Starting row',
    },
  },
}

const CRUD_MESSAGES_ES: CrudMessages = {
  clearSelection: 'Limpiar selección',
  actions: {
    create: 'Nuevo',
    clone: 'Clonar',
    update: 'Editar',
    delete: 'Eliminar',
    enable: 'Encender',
    disable: 'Apagar',
    bulkEdit: '',
    add: 'Añadir',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Atrás',
    accept: 'Aceptar',
    uploading: '',
  },
  sections: {
    details: 'Detalles',
    configuration: 'Configuración',
  },
  restricted: {
    [RestrictedValueEnum.READ]: 'Restringido',
  },
  status: {
    enabled: 'Encendido',
    disabled: 'Apagado',
  },
  schedule: {
    from: 'Desde el {date}',
    to: 'Hasta el {date}',
    always: 'Siempre',
  },
  empty: 'Vacío',
  search: 'Buscar',
  strictMatchingTooltip: '',
  noDataFound: `No hemos podido encontrar datos que se ajusten a la búsqueda.`,
  dataFiltered: ` Prueba a eliminar algunos filtros y buscar de nuevo.`,
  pagination: {
    rows: 'filas',
    pages: {
      first: 'Primera página',
      previous: 'Página anterior',
      next: 'Siguiente página',
      last: 'Última página',
    },
    ofTotal: 'de',
    download: {
      action: 'Descargar',
      actionTitle: 'Descargar informe',
      currentPage: 'Página actual',
      allRows: 'All rows',
      custom: 'Personalizada',
      startingRow: 'Fila inicial',
    },
  },
}

export const CRUD_MESSAGES: Dictionary<{ crud: CrudMessages }> = {
  [LocaleEnum.ENGLISH]: {
    crud: CRUD_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    crud: CRUD_MESSAGES_ES,
  },
}
